import {
    Component,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    Renderer2,
    ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';

import {ItemOrderHistory} from 'app/buffer-graph/models/item-order-history/item-order-history';
import {ItemOrderHistoryFresh} from 'app/buffer-graph/models/item-order-history/item-order-history-fresh';
import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import {BufferGraphService} from 'app/buffer-graph/services/buffer-graph.service';
import {EventArgs} from 'app/slick-grid/models/event-args';
import {ISlickGridColumn} from 'app/slick-grid/interfaces/slick-grid-column'
import {OnDropdownFilteredEventArgs} from 'app/slick-grid/models/on-dropdown-filtered-event-args';
import {DataSorter} from 'app/slick-grid/models/data-sorter';
import {TabComponentBase} from 'app/buffer-graph/models/tab-component-base';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {CustomFunctionReturn} from "../../../slick-grid/models/custom-function-return";
import {BufferGraphDataExchangeService} from "../../services/buffer-graph-data-exchange.service";
import {ExcelWorkService} from "../../../services/excel-work.service";
import {ExportExcelColumn} from "../../../shared/models/export-excel-column";
import {ModuleTableName} from "../../../shared/models/module-table-name";
import {ResizeDirection} from "../../../resize-glyph/resize-glyph.component";
import {FreshItemActionLine} from "../../models/item-actions/fresh-item-action-line";
import {CommonDataService} from "../../../services/common-data.service";
import Timer = NodeJS.Timer;
import {ItemOrderHistoryLine} from "../../models/item-order-history/item-order-history-line";

type History = ItemOrderHistory | ItemOrderHistoryFresh;
type ExportData = { columns: ExportExcelColumn[], mainRows: any[], treeRows: any[], metaData: string[] };

@Component({
    selector: 'item-order-history',
    templateUrl: './item-order-history.component.html',
    styleUrls: ['../../../slick-grid/stocks-grid-style.css', '../../styles/tabs-styles.css', './item-order-history.component.css']
})
export class ItemOrderHistoryComponent extends TabComponentBase<History, ExportData>{//implements OnInit/*, AfterViewChecked*/, OnDestroy {
    constructor(
        graphService: BufferGraphService,
        exchangeService: BufferGraphDataExchangeService,
        excelService: ExcelWorkService,
        translateService: TranslateService,
        renderer: Renderer2,
        elementRef: ElementRef,
        private readonly commonData: CommonDataService
    ){
        super(graphService, exchangeService, excelService, translateService, renderer, elementRef);

        this.showAllData = new EventEmitter<void>();

        this.options = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            enableAsyncPostRender: true,
            boundary: 'body'
        };
        this.dataView = new Slick.Data.DataView<History>({inlineFilters: false});
        this.dataView.onRowsChanged.subscribe(() => this.setCellCssStyles());
        this.generateColumns = true;

        this.lineDataView = new Slick.Data.DataView<FreshItemActionLine>();
        this.lineOptions = {
            syncColumnCellResize: true,
            multiColumnSort: true,
            editable: false,
            enableAsyncPostRender: true,
            boundary: 'body'
        };

        this.translateService.get(['ItemOrderHistory', 'CwhOrders']).subscribe(t => {
            this.mainRowsSheetName = t['ItemOrderHistory'];
            this.treeRowsSheetName = t['CwhOrders'];
        })

        this.heightCoeff = {gr: 100, fgr: 0};

    }

    @ViewChild('grid')
    protected gridRef: SlickGridComponent;

    @Input()
    public isActive: boolean;

    public isFresh: boolean;

    @Input()
    private set fresh(value: boolean){
        if (this.isFresh === value && this.isFresh != null)
            return;

        this.isFresh = value;
    }

    private get fresh(): boolean{
        return this.isFresh
    }

    @Input()
    public allShown: boolean;

    private data: History[];

    @Input()
    private set orders(orders: History[]){
        this.data = orders;
        //setTimeout(() => {
        this.dropdownFilters = [];

        this.dataView.beginUpdate();
        this.dataView.setItems(this.getLinearDataTree(orders));
        //this.dataView.setFilter(o => this.filterOrder(o));
        this.dataView.endUpdate();
        this.gridRef.resizeGrid();
        //this.setCellCssStyles();


        // console.log(this.columns, ' set orders')
        if (this.columns && this.gridRef){
            // this.gridRef.setColumns(this.columns)
            //    this.setColumns();
        }

        //},
//            10);
    }

    @Input()
    private showCodes: boolean;


    @Input()
    public canSend: boolean;

    @Input()
    protected columnSettings: ColumnSettingsBase[];

    @Output()
    private readonly showAllData: EventEmitter<void>;

    private readonly statusFulfillmentStylesKey = 'status-fulfillment';

    public cellCssStyles: { [key: string]: Slick.CellCssStylesHash };

    public dropdownFilters: OnDropdownFilteredEventArgs<History>[];

    public showLineGrid: boolean;

    public loading: boolean;

    private timeout: Timer

    ngOnInit(){
        super.ngOnInit();
        this.gridPropsName = new ModuleTableName('Stocks', 'ItemOrderHistory', this.fresh ? 2 : 1);
        this.gridPropsNameLine = new ModuleTableName('Stocks', 'ItemOrderHistoryLine', this.fresh ? 2 : 1);
        console.log(this.fresh, this.gridPropsName, this.gridPropsNameLine, 'ngOnInit orderHistory')
    }

    public get verticalDirection(): ResizeDirection{
        return ResizeDirection.Vertical;
    }

    //# add custom formatter for display tree model if item is PBL good (add display hide button)
    protected addCustomFormatter = (columnSettings: ColumnSettingsBase[], columns: ISlickGridColumn<History>[]): void => {
        let hasCrossDock = (this.dataView.getItems() || []).some(o => o.crossDock != null);

        const formatValue = (r: any, c: any, v: any, col: any, order: any, formatter?: Slick.Formatter<any>): string => {
            let toggler = '';
            if (c === 0 && hasCrossDock && order.crossDock){
                toggler = `<span class="toggle fa-regular ${order.crossDock == null
                    ? ''
                    : order.crossDock.visible
                        ? 'fa-square-minus'
                        : 'fa-square-plus'} mr-1"></span>`;
            }
            return formatter ? `${toggler}${formatter(r, c, v, col, order)}` : `${toggler}${v === null ? '' : v}`;
        };


        columns.forEach(item => {
            let formatter = item.formatter ? item.formatter : null;
            item.formatter = item.formatter
                ? (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => formatter(r, c, v, col, o))
                : (row, cell, val, col, o) => formatValue(row, cell, val, col, o, null);
            // item.formatter = (row, cell, val, col, o) => formatValue(row, cell, val, col, o, (r, c, v) => formatter(r, c, v, col, o));
        })
    }

    //# generate line data for grid
    private getLinearDataTree = (orders: History[]): History[] => {
        const array: History[] = [];
        orders.forEach(o => {
            array.push(o);
            if (o.crossDock)
                array.push(o.crossDock);
        });
        // console.log(array, 'getLinearDataTree');
        return array;

    }

    //# set styles for grid cells
    private setCellCssStyles = (): void => {
        let styles: Slick.CellCssStylesHash = null;
        this.dataView.getItems().forEach(o => {
            const row = this.dataView.getRowById(o.id);
            if (row == null)
                return;

            let statusClass: string = this.helper.getClass(o.statusDescStyle),
                fulfillmentClass: string = this.helper.getClass(o.fulfillmentDescStyle),
                sentOrderClass: string = this.helper.getClass(o.sentOrderStyle);

            if (!statusClass && !fulfillmentClass && !sentOrderClass)
                return;

            if (styles == null)
                styles = {};

            styles[row] = {};
            if (statusClass != null)
                styles[row]['statusDesc'] = statusClass;
            if (fulfillmentClass != null)
                styles[row]['fulfillmentDesc'] = fulfillmentClass;
            if (fulfillmentClass != null)
                styles[row]['sentOrder'] = sentOrderClass;
        });

        this.cellCssStyles = {};
        if (styles !== null){
            this.cellCssStyles[this.statusFulfillmentStylesKey] = styles;
        }
    }

    //# set filter and add custom functions to filter
    public setFilter = (val: boolean): void => {
        if (!val){
            return;
        }

        this.setFilterZoom();

        this.gridRef.filterHelper.startFilter = (order: any): CustomFunctionReturn => {
            if (order.isCwhOrder)
                return new CustomFunctionReturn(true, order.visible && !order.hiddenByFilter);
        };

        this.gridRef.filterHelper.endLoopFilterChange = (order: any): CustomFunctionReturn => {
            if (order.crossDock != null)
                order.crossDock.hiddenByFilter = true;
            return new CustomFunctionReturn(false, false);
        };

        this.gridRef.filterHelper.endFilterChange = (order: any): CustomFunctionReturn => {
            if (order.crossDock != null){
                order.crossDock.hiddenByFilter = false;
            }
            return this.filterByDate.filter(order);
        };

        this.dataView.setFilter(o => this.gridRef.filterHelper.filter(o));

        const rowHeightFilterFunc = (rows: any[]): any[] => {
            return rows.filter(row => row.visible)
        }

        const customRowLength = (length: number, wordLength: number, row: any, i: number): number => {
            if (length === 0 && i === 0 && row.crossDock){
                length = 16.5
            }
            return length
        }

        this.helper.wait(() => {
            this.gridRef.customRowHeightFilterFunc = rowHeightFilterFunc;
            this.gridRef.customRowLength = customRowLength;
            this.tab.customRowHeight && this.setCustomRowHeightState(this.tab.customRowHeight, this.gridRef)
        }, 5)

    }

    /*//# show all data (not use now)
    private onShowAllClick = (): void =>{
        if (this.allShown)
            return;

        this.showAllData.emit();
    }*/

    //# expand or collapse row in grid if item is PBL
    public onGridClick = (args: EventArgs<Slick.OnClickEventArgs<History>>): void => {
        args.event.stopPropagation();

        const order = this.dataView.getItem(args.data.row);
        if (this.showLineGrid){
            this.getAdditionalInfo(order.orderId, 1000)
            // this.lineDataView.setItems(order.additionalInfo);
            // this.gridLineRef && this.gridLineRef.invalidate();
        }

        if (args.data.cell !== 0)
            return;
        const target = (args.event as UIEvent).target;
        if (!(target instanceof HTMLElement) || !(target as HTMLElement).classList.contains('toggle'))
            return;

        if (order.crossDock == null)
            return;
        order.crossDock.visible = !order.crossDock.visible;
        this.dataView.updateItem(order.id, order);

        if (this.setCustomRowHeight){
            this.gridRef.calculateRowHeight(order);
            this.gridRef.removeEmptyRows();
            this.gridRef.addEmptyRows();
        }
    }


    //# expand or collapse row in grid if item is PBL
    public onDblGridClick = (args: EventArgs<Slick.OnClickEventArgs<History>>): void => {
        args.event.stopPropagation();
        this.showLineGrid = true;
        if (this.heightCoeff.gr === 100){
            this.heightCoeff = {gr: 75, fgr: 25};
        }
        const order = this.dataView.getItem(args.data.row);

        this.getAdditionalInfo(order.innerOrderId, 250);
    }

    private readonly getAdditionalInfo = (orderId: number, wait: number = 750): void => {

        if (this.timeout){
            clearTimeout(this.timeout)
            this.timeout = null;
        }
        this.loading = true;
        this.timeout = setTimeout( () => {
            this.graphService.getItemOrderHistoryLine(orderId).subscribe(res => {
                this.loading = false;
                if (!res || !res.success){
                    this.translateService.get('GetAdditionalOrderHistoryError')
                        .subscribe(error => this.commonData.showErrors([error]));
                    return;
                }

                const createAdditionalInfo = (item: ItemOrderHistoryLine[]): ItemOrderHistoryLine[] => {
                    return item.map((it, i) => new ItemOrderHistoryLine(
                        i + 1,
                        it.status,
                        it.date,
                        it.orderDate,
                        it.planArriveDate,
                        it.supplierCode,
                        it.initialOrder,
                        it.sentOrder,
                        it.confirmedOrder,
                        it.orderArriveDate,
                        it.itInputDate,
                        it.arrivedQuantity,
                        it.cancelCode,
                        it.documentNo
                    ))
                }

                this.lineDataView.setItems(createAdditionalInfo(res.result));
                this.gridLineRef
                    ? this.gridLineRef.invalidate()
                    : this.helper.wait(() => {
                        this.gridLineRef && this.gridLineRef.invalidate();
                    }, 100);
            })
        }, wait)

    }

    /**
     * hide line grid
     * @param val
     */
    public hideLineGrid = (val: boolean): void => {
        this.showLineGrid = false;
        this.heightCoeff = {gr: 100, fgr: 0};
        this.resizeGrids = true;
    }

    //# custom generate data for export in excel
    protected getExportData = (): ExportData => {

        const columns = this.helper.getColumnsForExcelExport(this.gridRef.getColumns());

        let mainRows = [],
            treeRows = [],
            metaData: string[] = [];

        /*const pushToRow = (val: any, array: any[]): void =>{
            if (moment.isMoment(val))
                array.push(val.toJSON());
            else if (moment.isDuration(val))
                array.push(moment(val.asMilliseconds()).toJSON());
            else
                array.push(`${val == null ? '' : val}`);
        };*/

        const saveRow = (row: any, val: any, prop: string, convRow: any): void => {

            if (moment.isMoment(val)){
                convRow[prop] = val.toJSON();
            } else if (moment.isDuration(val)){
                convRow[prop] = moment(val.asMilliseconds()).toJSON();
            } else{
                convRow[prop] = `${val == null ? '' : val}`;
            }
        };

        /*const updateProps = (row: any): void => {
            row.statusDescStyle = row.status;
            delete row.status;
            row.fulfillmentDescStyle = row.fulfillment;
            delete row.fulfillment;
        }*/

        const length = this.dataView.getLength();
        for (let i = 0; i < length; i++){
            const order: any = this.dataView.getItem(i);
            if (order.hideRow) { continue; }
            // const order2 = this.dataView.getItem(i);
            // console.log(order, 'order')
            // console.log(order2, 'order2')

            if (order.isCwhOrder)
                continue;

            const mainRow: any = {};
            const treeRow: any = order.crossDock ? {} : null;

            for (let prop in order){
                let found = prop.match(/[\w\-]+Style/);
                if (found){
                    metaData.push(prop);
                    saveRow(order, order[prop], prop, mainRow);
                    if (treeRow){
                        saveRow(order.crossDock, order.crossDock[prop], prop, treeRow);
                    }
                }
            }
            columns.forEach(c => {
                saveRow(order, order[c.field], c.field, mainRow);
                if (treeRow){
                    saveRow(order.crossDock, order.crossDock[c.field], c.field, treeRow);
                }
            });

            mainRows.push(mainRow);

            if (treeRow){
                treeRows.push(treeRow);
            }
        }

        metaData = this.helper.checkUniqueByObj(metaData);

        // console.log(mainRows, 'mainRows')
        // console.log(cwhRows, 'cwhRows')
        // console.log(metaData, 'metaData')

        !mainRows.length ? mainRows = null : null;
        !treeRows.length ? treeRows = null : null;

        return {columns, mainRows, treeRows, metaData};
    }

    //# download excel
    public onDownloadClick = (): void => {
        const fileName = `${this.mainRowsSheetName}_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`;
        this.download(data => this.excelService.downloadFullReport(
            data.columns,
            data.mainRows,
            data.treeRows,
            data.metaData,
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            this.treeRowsSheetName,
            'descCode',
            [this.gridPropsName],
            this.isFresh ? 1 : 0,
            this.mainRowsSheetName,
            []
        ).map(file => {
            return {fileContent: file, fileName};
        }));
    }

    //# send excel to email
    public onSendClick = (): void => {
        this.sendToEmail(data => this.excelService.sendFullReport(
            this.tab.itemInfo.sku,
            this.tab.itemInfo.warehouseCode,
            data.columns,
            data.mainRows,
            data.treeRows,
            data.metaData,
            [],
            this.translateService.currentLang,
            this.mainRowsSheetName,
            this.treeRowsSheetName,
            'descCode',
            [this.gridPropsName],
            this.isFresh ? 1 : 0,
            this.mainRowsSheetName,
            [],
            `${this.mainRowsSheetName}_SKU_${this.tab.itemInfo.sku}_Wrh_${this.tab.itemInfo.warehouseCode}.xlsx`
        ));
    }

    //# add custom sorter for grid
    public onGridSort = (args: EventArgs<Slick.OnSortEventArgs<History>>): void => {
        const sorter = new DataSorter<History>();
        const sort: (a: History, b: History) => number = args.data.multiColumnSort
            ? (a, b) => sorter.multiColumnSorter(a, b, args.data.sortCols)
            : (a, b) => sorter.sorter(a, b, args.data.sortCol, args.data.sortAsc);
        this.data.sort(sort);
        this.dataView.setItems(this.getLinearDataTree(this.data));
    }

    public onGridFiltered = (args: EventArgs<OnDropdownFilteredEventArgs<History>>): void => {
        // this.gridRef.filterHelper.onGridFiltered(args);
        // this.dataView.refresh();
    }

    public removeSort = (): void => {
        this.data.sort((a: any, b: any) => {
            return a['id'] - b['id'];
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/components/item-order-history.component/item-order-history.component.ts